

import React from 'react';
import { MagstimFetch, CurrentLang, CurrentTheme } from "common";
import { Col, Button } from 'reactstrap';
import * as CsvUtils from 'common/utils/CsvUtils';

class MagstimExportableTableBase extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            apiData: [],
            apiEndPoint: '',
            exportFileName: '',
            guidsFromLastAPICall: ''
        };

        this._table = React.createRef();
    }

    // eslint-disable-next-line no-unused-vars
    onClickExportTable = (event) => {
        // console.log('onClickExportTable');
        if (this._table !== undefined && this._table !== null) {
            CsvUtils.downloadAsCSV(document, this.state.exportFileName, this._table.current.getColumns(), this._table.current.getFilteredData());
        }
    }

    loadDataFromAPI() {
        if(this.props.Guids !== undefined && this.state.guidsFromLastAPICall !== undefined){
            if(this.props.Guids === this.state.guidsFromLastAPICall){
                return;
            }
        }

        if(this.state.apiEndPoint !== undefined){
            MagstimFetch.getAnalyticsWithOptionalGuids(this.state.apiEndPoint, this.props.Guids)
            .then((data) => {
                this.setState({ apiData: data, guidsFromLastAPICall: this.props.Guids})
            })
            .catch((error) => {
                console.log(error);
                alert(error);
            });
        }
    }

    getFilteredData = () => {

        const data = this.state.apiData;

        // Iterate over the selected filter
        if (data[this.props.selectedFilter] !== undefined && data[this.props.selectedFilter] !== null) {
            if (data[this.props.selectedFilter].Map !== undefined && data[this.props.selectedFilter].Map !== null) {
                return data[this.props.selectedFilter].Map;
            }
        }

        return [];
    }

    getTable(){
        return this._table.current;
    }

    componentDidUpdate(prevProps) {

        // Update the UI based on the filter settings
        if (this._table && this._table.current) {

            const tableData = this.getTableData(this.getFilteredData());
            this._table.current.initForSelect(tableData);
            this._table.current.resetFilters();

        }
    }

    componentDidMount() {
        alert('Function must be overridden!');
    }

    getTable = () => {
        alert('Function must be overridden!');
    }

    getTableData = () => {
        alert('Function must be overridden!');
    }

    exportDisabled = () =>{

        if (this._table && this._table.current) {

            const tableData = this.getTableData(this.getFilteredData());
            if(tableData !== null && tableData !== undefined && tableData.length > 0){
                return false;
            }
        }

        return true;
    }

    render() {
        return <>
            {this.getTable()}
            <Col className="pt-1 pr-0 pb-2 mt-3 mr-3 text-right">
                <Button color="primary" disabled={this.exportDisabled()} className="pl-5 pr-5" onClick={this.onClickExportTable} size={CurrentTheme().ControlSize} ><i className="fas fa-file-excel pr-2"></i> {CurrentLang().table_export_title}</Button>
            </Col>
        </>;
    }
}

export default MagstimExportableTableBase 